/** Length-step temporary measure-tool line/pill visuals. */
export const LengthMeasurement = {
	/** Temporary measure-tool line/pill. */
	measureLabelPrefix: 'length-measure',
	/** Frame-length and external dimension labels drawn around the plan. */
	frameLengthLabelPrefix: 'frame-length',
	/** ROME primary (theme gold) — distinct from the pink frame measurements. */
	measureLabelColor: 0xb59855,
} as const;
